<template>
    <SimpleButton class="nobreak order_button" @click="onButtonClick()">
        <img :src="ascending_icon"
            :class="['order_icon', column == globalSortColumn && sortDirection == 'asc' ? 'drawn_asc' : 'hidden']" />
        <img :src="descending_icon"
            :class="['order_icon', column == globalSortColumn && sortDirection == 'desc' ? 'drawn_dsc' : 'hidden']" /><img
            :src="neutral_icon" :class="['order_icon', column != globalSortColumn ? 'drawn_no_order' : 'hidden']" />
    </SimpleButton>
</template>
<script>
import SimpleButton from "./SimpleButton.vue";

export default {
    name: "SortButton",
    components: {
        SimpleButton
    },
    data() {
        return {
            publicPath: "http://" + window.location.hostname,
        };
    },
    props: {
        globalSortColumn: {
            type: String,
            default: '',
        },
        column: {
            type: String,
            default: '',
        },
        sortDirection: {
            type: String,
            default: '',
        },
    },
    computed: {
        ascending_icon: function () { return `${this.publicPath}/order_ascending.png` },
        descending_icon: function () { return `${this.publicPath}/order_descending.png` },
        neutral_icon: function () { return `${this.publicPath}/order_neutral.png` },
    },
    methods: {
        onButtonClick() {
            this.$emit('click');
        },
    },
};
</script>
<style scoped>
.drawn_no_order {
    color: #dddddd;
    display: block;
    visibility: visible;
    filter: brightness(1.7);
}

.nobreak {
    white-space: nowrap;
}

.drawn_asc {
    display: block;
    visibility: visible;
    filter: brightness(0.15) sepia(100%) hue-rotate(135deg) saturate(5000%);
}

.drawn_dsc {
    display: block;
    visibility: visible;
    filter: brightness(0.15) sepia(100%) hue-rotate(45deg) saturate(5000%);
}

.order_button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    padding: 0;
}

.order_icon {
    width: 16px;
    height: 16px;
    object-fit: contain;
}

.hidden {
    display: none;
    visibility: hidden;
}
</style>